"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoveredAnywhereWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var InfoModal_1 = require("../../../../components/modals/InfoModal");
var ValuableItems_1 = require("./ValuableItems");
var services_1 = require("@falcon/services");
var CoveredAnywhereWidget = /** @class */ (function (_super) {
    __extends(CoveredAnywhereWidget, _super);
    function CoveredAnywhereWidget(props) {
        var _this = _super.call(this, props) || this;
        !_this.props.interaction.valuableItems && (_this.props.interaction.valuableItems = []);
        return _this;
    }
    CoveredAnywhereWidget.prototype.renderInputField = function () {
        return React.createElement(React.Fragment, null, this.renderContent());
    };
    CoveredAnywhereWidget.prototype.renderContent = function () {
        return (React.createElement("div", { className: "items-take-away-widget _panel pt-4 pb-1" },
            React.createElement("div", { className: "d-flex justify-content-between align-items-start" },
                this.props.interaction.process === services_1.INTERACTION_PROCESS_NB
                    ? React.createElement("div", null, "Do you have any of the following items you'd like to cover?")
                    : React.createElement("div", null, "Please add any of the following items you'd like to cover"),
                React.createElement(InfoModal_1.InfoModal, { className: "ml-3", title: "Specified items" },
                    React.createElement("p", null,
                        "Think about items like phones, laptops, cameras, bikes or jewellery.  You can add up to ",
                        React.createElement("b", null, "10 items with a maximum limit of \u00A35,000 for any one item up to a maximum of \u00A320,000 in total.")),
                    React.createElement("p", null,
                        React.createElement("b", null, "You can choose where you want the item covered \u2013 inside the home only or inside and outside of the home. You don\u2019t need to specify items worth \u00A32,000 or less unless you need cover outside of the home. "),
                        "And good news, you\u2019ll be covered for accidental loss, damage and theft if you choose to cover the items outside of the home."),
                    React.createElement("p", null,
                        "You can also add any ",
                        React.createElement("b", null, "items worth more than \u00A32,000 that stay in the home e.g. TVs or artwork. "),
                        "If you need accidental damage cover for these items,",
                        React.createElement("b", null, " you\u2019ll need to include optional accidental damage cover under contents. You don\u2019t need to specify furniture items, "),
                        "as these are covered within your overall contents limit of cover."),
                    React.createElement("p", null,
                        React.createElement("b", null, "Your specified items are included in your total contents limit of cover, so please check you have enough cover.")))),
            React.createElement("div", { className: "mt-3 p-3 bg-white-blue rounded" },
                "We need to know about:",
                React.createElement("ul", null,
                    React.createElement("li", null,
                        React.createElement("b", null, "any item"),
                        " that you want to ",
                        React.createElement("b", null, "cover outside the home")),
                    React.createElement("li", null,
                        React.createElement("b", null, "items worth over \u00A32,000"),
                        " that you want to ",
                        React.createElement("b", null, "cover inside the home"))),
                "(Think about items like smartphones, laptops, bicycles, artwork, jewellery etc.)"),
            React.createElement(ValuableItems_1.default, __assign({}, this.props))));
    };
    return CoveredAnywhereWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.CoveredAnywhereWidget = CoveredAnywhereWidget;
//# sourceMappingURL=CoveredAnywhereWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/coveredAnywhereWidget/CoveredAnywhereWidget.js
// module id = 2556
// module chunks = 0